/**
 * Gets authorization header bearer value
 * @param token JWT to get bearer value with
 * @returns Authorization header bearer value.
 */
export var getAuthBearerValue = function (token) {
    return "Bearer" /* Bearer */ + " " + token;
};
